export enum WeekIndex {
    THIS_WEEK = 0,
    NEXT_WEEK = 1,
}